import React from 'react';
import './App.css';
import CybersecurityMapper from './components/CybersecurityMapper';

function App() {
  return (
    <div className="App">
      <CybersecurityMapper />
    </div>
  );
}

export default App; 